import angular from 'angular';
import { RegistrationGroup } from '../model/registrationGroup';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import moment from 'moment';
import DocumentService from '@/shared/services/DocumentService';
import {
  getFirstSelectedInvoiceStream,
  resourceMatchesFilters,
  sanitizeReferenceYear,
} from '@/shared/components/registration/registrationHelpers';

angular.module('cxRegistrations').directive('cxRegistrationGroupInput', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: require('./registrationGroupInput.html'),
      scope: {
        date: '=',
        value: '=',
        save: '&',
        afterSave: '&',
        cancel: '&',
        onDateChanged: '&dateChanged',
        onTaskStatusChanged: '&taskStatusChanged',
      },
      controller: [
        '$scope',
        'dataCache',
        'resourceFactorySvc',
        'registrationService',
        'dialogsSvc',
        'userData',
        'flySvc',
        'checkSecurity',
        'checkFeature',
        '$rootScope',
        'priceService',
        'resourceNameFilter',
        '$q',
        '$http',
        'appUrls',
        'translateListFilter',
        '$state',
        '$window',
        'invoiceStreamNameFilter',
        function(
          $scope,
          dataCache,
          resourceFactorySvc,
          registrationService,
          dialogsSvc,
          userData,
          flySvc,
          checkSecurity,
          checkFeature,
          $rootScope,
          priceService,
          resourceNameFilter,
          $q,
          $http,
          appUrls,
          translateListFilter,
          $state,
          $window,
          invoiceStreamNameFilter,
        ) {
          $scope.registrationService = registrationService;

          $scope.editReg = null;
          $scope.editRegCopy = null;
          $scope.workResources = [];
          $scope.travelResources = [];
          $scope.costResources = [];
          $scope.isReadOnly = false;
          $scope.userId = dataCache.getArray('employee').userID;
          $scope.btnDisabled = false;
          $scope.resources = [];
          $scope.interactionType = null;
          $scope.plannedTasks = [];
          $scope.task = null;
          $scope.taskStatus = null;
          $scope.interactionAttachments = [];

          $scope.getInvoiceStreamLabel = invoiceStreamNameFilter;

          $scope.ckeditorOptions = {
            autoGrow_minHeight: 50,
            height: 50,
          };

          var reset = function() {
            //Restore registration object to state before editing
            if ($scope.editReg && $scope.editReg.group && $scope.editRegCopy)
              $scope.editReg.fromJson($scope.editRegCopy);
            $scope.editReg = null;
            $scope.editRegCopy = null;
            $scope.interactionAttachments = [];
            $scope.taskStatus = null;

            $scope.$broadcast('$cxFormClosing');
          };

          var resetCollapsed = function() {
            if (!$scope.editReg || !$scope.editReg.group) {
              var userSettings = userData.get('regInput', {
                isWorkCollapsed: false,
                isTravelCollapsed: true,
                isCostsCollapsed: true,
                isRemarksCollapsed: false,
                isCommunicationCollapsed: true,
              });

              $scope.isWorkCollapsed = userSettings.isWorkCollapsed;
              $scope.isTravelCollapsed = userSettings.isTravelCollapsed;
              $scope.isCostsCollapsed = userSettings.isCostsCollapsed;
              $scope.isRemarksCollapsed = userSettings.isRemarksCollapsed;
              $scope.isCommunicationCollapsed = userSettings.isCommunicationCollapsed;
            } else {
              $scope.isWorkCollapsed = !$scope.editReg.work.id;
              $scope.isTravelCollapsed = !$scope.editReg.travel.id;
              $scope.isCostsCollapsed = !$scope.editReg.cost.id;
              $scope.isRemarksCollapsed = !$scope.editReg.remark;
              $scope.isCommunicationCollapsed = true;
            }
          };

          var resourceSelected = function(registration, retrieveOnly) {
            registration.priceOptions = null;
            if (registration.hasResource && registration.resource.type === 3) {
              if (!retrieveOnly) {
                registration.quantity = 0.0;
                registration.price = null;
                registration.amount = 0.0;
                registration.discountPercentage = 0.0;
                registration.isBillable = false;
                registration.inForfait = null;
                registration.isFixedPrice = false;
              }
            } else if (registration.hasResource && !registration.resource.isOther) {
              // Only load price options when user has permissions
              if (checkSecurity('Pricelist:r')) {
                $scope.btnDisabled = true;
                priceService
                  .getPrice({
                    category: registration.resource.categoryId,
                    invoiceStream: registration.invoiceStreamId,
                    user: registration.userId,
                  })
                  .then(function(price) {
                    if (price) {
                      registration.priceOptions = [price];
                      if (!retrieveOnly && !registration.price) {
                        registration.price = price;
                      }
                      if (!registration.group) {
                        registration.price = price;
                      }
                    }
                  })
                  .finally(function() {
                    $scope.btnDisabled = false;
                  });
                if (
                  (!retrieveOnly || registration.inForfait === null) &&
                  !!registration.invoiceStreamId
                ) {
                  priceService
                    .isResourceInForfait({
                      resource: registration.resource.id,
                      invoiceStream: registration.invoiceStreamId,
                    })
                    .then(function(inForfait) {
                      registration.inForfait = inForfait;
                    });
                }
              }

              if (!retrieveOnly) {
                if (
                  (registration.resource.type === 1 || registration.resource.type === 2) &&
                  registration.quantity === 0
                )
                  registration.quantity = 1;
                registration.vatPercentage = registration.resource.vatPercentage;
                registration.vatType = registration.resource.vatType;
                registration.isBillable = registration.resource.isBillable;
                registration.isFixedPrice = registration.resource.isFixedPrice;
                //if (registration.type === 0 && registration.durationMinutes === 0) registration.durationMinute = 15; TFS 10935
              }
            } else if (!retrieveOnly) {
              registration.quantity = 0.0;
              registration.price = null;
              registration.amount = 0.0;
              registration.discountPercentage = 0.0;
              registration.isBillable = true;
              registration.isFixedPrice = false;
            }
          };

          //Watch the value attribute for changes
          $scope.$watch('value', function(newValue, oldValue) {
            reset();
            if (newValue) {
              $scope.editReg = newValue;
              $scope.editRegCopy = newValue.toJson(false);
              $scope.editReg.task = null;
              $scope.taskStatus = null;
              $scope.retrieveResources().then(function() {
                resourceSelected($scope.editReg.work, true);
                resourceSelected($scope.editReg.travel, true);
                resourceSelected($scope.editReg.cost, true);
              });
              $scope.retrievePlannedTasks().then(function() {
                const plannedTaskId = $scope.editReg.getPlannedTaskId();

                if (plannedTaskId) {
                  $scope.editReg.task = $scope.plannedTasks.find(
                    x => x.plannedTaskId === plannedTaskId,
                  );
                  $scope.resetTaskStatus();
                }
              });
              if ($scope.editReg.relation && !$scope.editReg.invoiceStreamId) {
                $scope.relationChanged();
              }
              var userId =
                $scope.editReg.work.userId ||
                $scope.editReg.travel.userId ||
                $scope.editReg.cost.userId;
              $scope.isReadOnly =
                !!userId && userId !== $scope.userId
                  ? !checkSecurity('RegistrationOthers:u')
                  : !checkSecurity('RegistrationOwn:u');
            } else {
              $scope.editReg = new RegistrationGroup();
              $scope.editReg.date = $scope.date;
              $scope.editRegCopy = null;
              $scope.isReadOnly = !checkSecurity('RegistrationOwn:c');
            }
            $scope.editReg.referenceYear = sanitizeReferenceYear(
              $scope.editReg.referenceYear,
              $scope.editReg.date,
            );
            resetCollapsed();
            setTimeout(function() {
              $('#RelationField').focus();
            }, 250);
          });

          $scope.dateChanged = function() {
            if (!$scope.editReg.group) {
              // New registration
              $scope.date = $scope.editReg.date;
              if (!$scope.editReg.hasTask()) {
                $scope.editReg.referenceYear = sanitizeReferenceYear(null, $scope.editReg.date);
              }
              $scope.onDateChanged({ date: $scope.date });
            }
          };

          $scope.relationChanged = function() {
            const relation = $scope.editReg.relation;
            if (relation && relation.id && !relation.invoiceStreams) {
              //Recent relation selected. Retrieve relation again with invoice streams
              return resourceFactorySvc
                .get('relation')
                .ids(null, [relation.id])
                .$promise.then(
                  ([rel] = []) => {
                    if (rel && rel.id && rel.invoiceStreamId) {
                      $scope.editReg.relation = rel;
                      $scope.relationChanged();
                    } else {
                      $scope.editReg.relation = null;
                      $scope.relationChanged();
                    }
                  },
                  error => {
                    flySvc.error(error);
                    $scope.editReg.relation = null;
                    $scope.relationChanged();
                  },
                );
            }

            $scope.editReg.invoiceStream = getFirstSelectedInvoiceStream(relation);
            $scope.editReg.invoiceStreamId = $scope.editReg.invoiceStream?.id;

            $scope.editReg.work.inForfait = null;
            $scope.editReg.travel.inForfait = null;
            $scope.editReg.cost.inForfait = null;

            $scope.checkIfResourcesMatchFilters();
            $scope.selectTask(null);

            $scope.retrievePlannedTasks();
          };

          $scope.checkIfResourcesMatchFilters = function() {
            const relation = $scope.editReg.relation;
            const invoiceStream = $scope.editReg.invoiceStream;
            if ($scope.editReg.work.resource) {
              if (
                !resourceMatchesFilters(
                  $scope.editReg.work.resource,
                  relation?.crm,
                  invoiceStream?.assignmentTemplateId,
                )
              ) {
                $scope.editReg.work.resource = null;
              }
              resourceSelected($scope.editReg.work, true);
            }
            if ($scope.editReg.travel.resource) {
              if (
                !resourceMatchesFilters(
                  $scope.editReg.travel.resource,
                  relation?.crm,
                  invoiceStream?.assignmentTemplateId,
                )
              ) {
                $scope.editReg.travel.resource = null;
              }
              resourceSelected($scope.editReg.travel, true);
            }
            if ($scope.editReg.cost.resource) {
              if (
                !resourceMatchesFilters(
                  $scope.editReg.cost.resource,
                  relation?.crm,
                  invoiceStream?.assignmentTemplateId,
                )
              ) {
                $scope.editReg.cost.resource = null;
              }
              resourceSelected($scope.editReg.cost, true);
            }
          };

          $scope.selectResource = function(registration) {
            registration.price = null;
            resourceSelected(registration);
          };

          var translateResources = function() {
            $scope.resources = $scope.resources
              .map(item => ({ ...item, name: resourceNameFilter(item), code: item.code || '' }))
              .sort(dynamicSortMultiple('code', 'name'));
          };

          $scope.$on('$destroy', function() {
            $rootScope.$on('$translateChangeSuccess', translateResources);
            if ($scope.resourceRequest && $scope.resourceRequest.$cancelRequest)
              $scope.resourceRequest.$cancelRequest();
          });

          //Retrieves the resources after selecting a relation.
          $scope.resourcePromise = null;
          $scope.retrieveResources = function() {
            if ($scope.resourcePromise) return $scope.resourcePromise;

            $scope.resourceRequest = resourceFactorySvc.get('resource').reg(
              {
                type: -1,
              },
              function(data) {
                $scope.workResources = [];
                $scope.travelResources = [];
                $scope.costResources = [];
                $scope.resources = data;

                translateResources();

                if ($scope.resources) {
                  for (var i = 0; i < $scope.resources.length; i++) {
                    if ($scope.resources[i].type === 1) {
                      $scope.costResources.push($scope.resources[i]);
                    } else if ($scope.resources[i].type === 2) {
                      $scope.travelResources.push($scope.resources[i]);
                    } else if ($scope.resources[i].type === 0) {
                      $scope.workResources.push($scope.resources[i]);
                    }
                  }
                }
              },
            );

            return ($scope.resourcePromise = $scope.resourceRequest.$promise);
          };
          $scope.$watch('editReg.interactionId', function() {
            $scope.retrieveInteracationAttachments();
          });

          $scope.$watch('editReg.work.date', function(newValue, oldValue) {
            if ($scope.editReg && !$scope.editReg.hasTask() && !$scope.editReg.group) {
              $scope.editReg.referenceYear = sanitizeReferenceYear(null, $scope.editReg.date);
            }
            $scope.retrieveResources().then(function() {
              if ($scope.editReg) {
                resourceSelected($scope.editReg.work, true);
                resourceSelected($scope.editReg.travel, true);
                resourceSelected($scope.editReg.cost, true);
              }
            });
          });

          $scope.cancelReg = function() {
            reset();
            $scope.value = null;
            $scope.cancel();
          };

          $scope.saveReg = function() {
            if ($scope.editReg && $scope.editReg.validate()) {
              $scope.btnDisabled = true;

              const interactionModel = createInteractionModel();
              const interactionId = $scope.editReg.interactionId;

              $scope
                .save({
                  reg: $scope.editReg,
                })
                .then(updatedReg => {
                  if (updatedReg) {
                    //Create interaction
                    try {
                      if (interactionModel) {
                        return createOrUpdateInteraction(interactionModel, updatedReg.group)
                          .then(({ data: interaction }) => {
                            if (interaction) {
                              $scope.linkAttachments(interaction.id, updatedReg.relation.id);
                            }
                          })
                          .then(() => updatedReg);
                      } else if (interactionId) {
                        //Interactioon exists but was not updated
                        return $scope
                          .linkAttachments(interactionId, updatedReg.relation.id)
                          .then(() => updatedReg);
                      }
                    } catch (e) {
                      console.error(e);
                    }
                  }
                  return updatedReg;
                })
                .then(reg => {
                  //Trigger event after save (close dialog/form)
                  if (reg) $scope.afterSave({ reg });
                  return reg;
                })
                .finally(function() {
                  $scope.btnDisabled = false;
                });
            } else {
              flySvc.error('registrationFormContainsErrors');
            }
          };
          $scope.emptyInteractionDescription =
            '<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;"></body>\n</html>\n';
          function createInteractionModel() {
            if (!$scope.editReg) return null;
            if ($scope.editReg.interactionType === null) return null;
            if (
              $scope.editReg.interactionTitle === null &&
              $scope.editReg.interactionDescription === null
            )
              return null;

            const interactionChanged =
              (!$scope.editReg.originalInteraction &&
                (($scope.editReg.interactionDescription &&
                  $scope.editReg.interactionDescription !== $scope.emptyInteractionDescription) ||
                  $scope.editReg.interactionTitle)) ||
              ($scope.editReg.originalInteraction &&
                (($scope.editReg.interactionDescription !=
                  $scope.editReg.originalInteraction.description &&
                  $scope.editReg.interactionDescription !== $scope.emptyInteractionDescription) ||
                  $scope.editReg.interactionTitle != $scope.editReg.originalInteraction.title ||
                  $scope.editReg.interactionType !=
                    $scope.editReg.originalInteraction.interactionType ||
                  $scope.editReg.originalInteraction.relationId != $scope.editReg.relation.id ||
                  !moment($scope.editReg.originalInteraction.date).isSame(
                    moment($scope.editReg.date),
                    'day',
                  )));
            if (!interactionChanged) return null;
            if ($scope.editReg.interactionId) {
              //Update
              // Create interaction date/time by combining registration date with start time
              const interactionDateTime = moment($scope.editReg.date)
                .startOf('day')
                .add($scope.editReg.work.fromMinutes || 0, 'minutes')
                .toDate();

              return {
                ...($scope.editReg.originalInteraction || {}),
                id: $scope.editReg.interactionId || null,
                description: $scope.editReg.interactionDescription,
                title: $scope.editReg.interactionTitle,
                interactionType: $scope.editReg.interactionType,
                title: $scope.editReg.interactionTitle,
                date: interactionDateTime,
                relationId: $scope.editReg.relation.id,
              };
            }
            // Create interaction date/time by combining registration date with start time for new interactions
            const interactionDateTime = moment($scope.editReg.date)
              .startOf('day')
              .add($scope.editReg.work.fromMinutes || 0, 'minutes')
              .toDate();

            return {
              description: $scope.editReg.interactionDescription,
              title: $scope.editReg.interactionTitle,
              interactionType: $scope.editReg.interactionType,
              date: interactionDateTime,
              relationId: $scope.editReg.relation.id,
              objectType: 1,
              objectId: $scope.editReg.group || null,
              interactionSource: 1,
            };
          }

          function createOrUpdateInteraction(model, group) {
            if (!model) return;
            if (model.id) {
              // update
              return $http.put(appUrls.interactions + '/api/interactions', model);
            } else {
              model.objectId = model.objectId || group;
              return $http.post(appUrls.interactions + '/api/interactions/create', model);
            }
          }

          $scope.calcDistance = function() {
            if (!$scope.editReg || !$scope.editReg.travel || !$scope.editReg.travel.relation.id)
              return;
            dialogsSvc
              .showDistanceDialog(
                $scope.editReg.travel.relation.id,
                $scope.editReg.travel.relation.companyId,
              )
              .then(function(result) {
                if (result) {
                  if (result.distance) $scope.editReg.travel.quantity = result.distance;
                  if (result.description) {
                    $scope.editReg.remark =
                      ($scope.editReg.remark ? $scope.editReg.remark + '\n' : '') +
                      result.description;
                  }
                }
              });
          };

          $scope.toggleCollapse = function(prop) {
            $scope[prop] = !$scope[prop];
            if (!$scope.editReg || !$scope.editReg.group) {
              userData.set('regInput', {
                isWorkCollapsed: $scope.isWorkCollapsed,
                isTravelCollapsed: $scope.isTravelCollapsed,
                isCostsCollapsed: $scope.isCostsCollapsed,
                isRemarksCollapsed: $scope.isRemarksCollapsed,
                isCommunicationCollapsed: $scope.isCommunicationCollapsed,
              });
            }
          };

          $scope.setInteractionType = function(interactionType) {
            if ($scope.editReg.interactionType === interactionType) {
              $scope.editReg.interactionType = null;
            } else {
              $scope.editReg.interactionType = interactionType;
            }
          };

          $scope.getTaskLabel = task =>
            task.plannedTaskName ||
            (task.plannedTaskTemplateId
              ? translateListFilter(
                  task.plannedTaskTemplateId,
                  'tasktemplate',
                  task.plannedTaskTemplateName || '',
                )
              : '');

          $scope.retrievePlannedTasks = function() {
            $scope.plannedTasks = [];
            if (!$scope.editReg || !$scope.editReg.invoiceStreamId)
              return $q.when($scope.plannedTasks);

            const currentTaskIds = $scope.editReg.getPlannedTaskIds() || [];
            return $http
              .post(appUrls.tasks + '/api/PlannedTasks/ForRegistrations', {
                invoiceStreamId: $scope.editReg.invoiceStreamId,
                includeIds: currentTaskIds,
              })
              .then(function({ data }) {
                $scope.plannedTasks = data
                  .reduce((array, orgMainTask, mainTaskIndex) => {
                    const { children = null, ...mainTask } = orgMainTask;
                    const mainTaskLabel = $scope.getTaskLabel(mainTask);
                    const mappedChildren = (children || []).map((orgSubTask, subTaskIndex) => {
                      const subtaskLabel = $scope.getTaskLabel(orgSubTask);
                      return {
                        ...orgSubTask,
                        label: subtaskLabel,
                        id: orgSubTask.plannedTaskId,
                        search: `${mainTaskLabel};${subtaskLabel}`,
                        level: 1,
                        order: mainTaskIndex * 100 + (subTaskIndex + 1),
                      };
                    });

                    const childLabels = mappedChildren.map(x => x.label).join(';');

                    return array.concat([
                      {
                        ...mainTask,
                        label: mainTaskLabel,
                        id: mainTask.plannedTaskId,
                        search: `${mainTaskLabel};${childLabels}`,
                        level: mainTask.isToDo ? 2 : 0,
                        order: mainTaskIndex * 100,
                      },
                      ...mappedChildren,
                    ]);
                  }, [])
                  .filter(x => !!x.label)
                  .sort(dynamicSortMultiple('order', 'label'));
                return $scope.plannedTasks;
              });
          };

          $scope.selectTask = function(task) {
            if (task && task.id) {
              const {
                plannedTaskId,
                plannedTaskName,
                plannedTaskTemplateId,
                plannedTaskTemplateType,
                mainPlannedTaskId,
                mainPlannedTaskName,
                mainTaskTemplateId,
                resourceId,
                year,
              } = task;

              $scope.editReg.setTaskFields({
                plannedTaskId,
                plannedTaskName,
                plannedTaskTemplateId,
                plannedTaskTemplateType,
                mainPlannedTaskId,
                mainPlannedTaskName,
                mainTaskTemplateId,
              });

              $scope.editReg.referenceYear = sanitizeReferenceYear(year, $scope.editReg.date);
              if (resourceId && $scope.editReg.work) {
                const resource = $scope.workResources.find(x => x.id === resourceId);
                if (resource) {
                  $scope.editReg.work.resource = resource;
                  $scope.editReg.work.price = null;
                  resourceSelected($scope.editReg.work, false);
                }
              }
            } else {
              if ($scope.editReg.hasTask())
                $scope.editReg.referenceYear = sanitizeReferenceYear(null, $scope.editReg.date);
              $scope.editReg.clearTaskFields();
              $scope.editReg.task = null;
            }
            $scope.resetTaskStatus();
          };

          $scope.selectInvoiceStream = function() {
            $scope.editReg.invoiceStream =
              ($scope.editReg &&
                $scope.editReg.invoiceStreamId &&
                $scope.editReg.relation &&
                $scope.editReg.relation.invoiceStreams &&
                $scope.editReg.relation.invoiceStreams.find(
                  x => x.id === $scope.editReg.invoiceStreamId,
                )) ||
              null;

            $scope.checkIfResourcesMatchFilters();
            $scope.selectTask(null);
            $scope.retrievePlannedTasks();
          };

          $scope.openRelationInNewWindow = function(event) {
            event.stopPropagation();
            event.preventDefault();
            if (!$scope.editReg || !$scope.editReg.relation || !$scope.editReg.relation.id) return;
            const url = $state.href('relations.detail', { relId: $scope.editReg.relation.id });
            $window.open(url, '_blank');
          };
          $scope.retrieveInteracationAttachments = function() {
            if (!$scope.editReg || !$scope.editReg.interactionId || !checkSecurity('Documents:r')) {
              $scope.interactionAttachments = [];
              return;
            }
            $http
              .get(`${appUrls.documents}/api/documents/Links/${$scope.editReg.interactionId}/6`)
              .then(({ data }) => {
                $scope.interactionAttachments = data || [];
              });
          };
          $scope.uploadAttachments = function(files) {
            if ($scope.editReg.isBilled || $scope.isReadOnly || !$scope.editReg.relation.id) return;
            if (!files || files.length < 1) return;
            var formData = new FormData();
            files.forEach(function(file) {
              formData.append('data', file.data);
            });

            $http({
              method: 'POST',
              url: appUrls.documents + '/api/documents?documentType=15',
              headers: {
                'Content-Type': undefined,
              },
              data: formData,
            })
              .then(function(response) {
                var result = response.data;
                if (result && result.length > 0) {
                  result.forEach(function(file) {
                    $scope.interactionAttachments.push(file);
                  });
                }
              })
              .catch(function(error) {
                flySvc.error(error);
                return '';
              });
          };
          $scope.deleteAttachment = function(attachment) {
            dialogsSvc.showYesNo('comfirmDeleteTitle', 'confirmDeleteAttachment').then(function() {
              // the attachment is a new document that was uploaded. Delete the corresponding document
              const documentId = attachment.documentId || attachment.id;
              $http
                .delete(appUrls.documents + '/api/documents/' + documentId)
                .then(function(response) {
                  var result = response.data;
                  var index = $scope.interactionAttachments.indexOf(attachment);
                  if (index >= 0) $scope.interactionAttachments.splice(index, 1);
                })
                .catch(function(error) {
                  flySvc.error(error);
                  return '';
                });
            });
          };

          $scope.linkAttachments = function(interactionId, relationId) {
            const documentLinks = [];

            $scope.interactionAttachments.forEach(attachment => {
              if (attachment.documentType !== 15) return;
              //Only link temp documents
              documentLinks.push({
                documentId: attachment.id,
                linkId: interactionId,
                linkType: 6,
                recognizeTemporaryDocuments: true,
              });

              if (relationId) {
                documentLinks.push({
                  documentId: attachment.id,
                  linkId: relationId,
                  linkType: 3,
                });
              }

              //Set documentType to unkown
              attachment.documentType = -1;
            });
            if (documentLinks.length === 0) return $q.when([]);
            return $http.post(`${appUrls.documents}/api/documents/linksmultiple`, documentLinks);
          };
          $scope.downloadAttachment = function(attachment) {
            DocumentService.download(attachment.documentId || attachment.id);
          };
          $scope.resetTaskStatus = function() {
            if (!$scope.editReg || !$scope.editReg.task || !$scope.editReg.task.plannedTaskId) {
              $scope.taskStatus = null;
              return;
            }
            const { plannedTaskId, status, mainPlannedTaskId, level } = $scope.editReg.task;

            $scope.taskStatus = {
              id: plannedTaskId,
              status: Math.min(2, status),
              isBlocked: status === 3,
              inapplicable: status === 4,
              rejected: status === 6,
              parentId: plannedTaskId !== mainPlannedTaskId ? mainPlannedTaskId : null,
              taskLevel: level,
            };
          };
          $scope.setTaskStatus = function(data) {
            if (!data) return;
            $scope.onTaskStatusChanged({ value: data }); //Notify parent screen if task status was changed
            if (!$scope.editReg) return;
            const task = $scope.editReg.task;
            if (!task || !task.plannedTaskId) return;
            if (angular.isArray(data)) {
              data.forEach($scope.updateTaskStatus);
              return;
            }
            $scope.updateTaskStatus(data);
          };
          $scope.updateTaskStatus = function(data) {
            if (!data) return;
            const task = $scope.editReg.task;
            if (task.plannedTaskId !== data.id) return;
            if (data.isBlocked) {
              task.status = 3;
            } else if (data.inapplicable) {
              task.status = 4;
            } else if (data.rejected) {
              task.status = 6;
            } else if (data.status <= 2) {
              task.status = data.status;
            }
            $scope.resetTaskStatus();
          };
        },
      ],
    };
  },
]);
